import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";
import { Reserva } from "../interfaces/Reserva";
import { formatDate } from "../../../uteis/dateUtils";

// Função para buscar as reservas

export const reservaService = async () => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/reserva`;

    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });

      const reservasArray = response.data.map((p: Reserva) => {
        const formattedDate = formatDate(p.dataReserva);
        return {
          ...p,
          key: p.id,
          dataReserva: formattedDate,
          idReservaOta: p.idReservaOta,
          periodoUsuario: p.periodoUsuarioId,
        };
      });

      return reservasArray; // Agora retorna o array processado
    } catch (error) {
      console.log(error);
    }
  }
  return []; // Retorna um array vazio se o Token não for válido
};

export {};
